<script setup lang="ts">
import { ref, watch } from 'vue'
import { RouterView } from 'vue-router'
import TopNavBar from '@/components/TopNavBar.vue'
import LoginDialog from '@/components/LoginDialog.vue'
import BugReportWidget from '@/components/BugReportWidget.vue'
import Toast from 'primevue/toast'
import ConfirmDialog from 'primevue/confirmdialog'

const buildInfo = ref<string>(__APP_BUILD_TIMESTAMP__ || 'local build')

import { useAuthStore } from '@/stores/auth'
const authStore = useAuthStore()

authStore.checkLoginStatus()

import { useDrawer } from './composables/useDrawer'
const drawer = useDrawer()

// const visible = ref<boolean>(false)

// watch for events being emitted
const toggleLoginDialog = () => {
  authStore.loginDialogVisible = !authStore.loginDialogVisible
}

watch(() => authStore.loginDialogVisible, (newValue) => {
  console.log('loginDialogVisible:', newValue)
})

</script>

<template>
  <div>
    <!-- Global components -->
    <Toast />
    <ConfirmDialog />
    
    <!-- <Button @click="visible = !visible">Show Dialog</Button> -->
    <!-- <InputText v-tooltip.top="'Enter your username'" type="text" placeholder="Top" /> -->
    <LoginDialog v-model="authStore.loginDialogVisible" />
    <TopNavBar @show-login-dialog="toggleLoginDialog" />
    <RouterView />
    <BugReportWidget />
    <Drawer
      v-model:visible="drawer.visible"
      :header="drawer.header"
      position="right"
      class="pad-drawer"
    >
      <!-- <p>
        Coherence in InSAR (Interferometric Synthetic Aperture Radar) data processing is a measure
        of how similar the radar signals are between two different observations of the same area. It
        ranges from 0 (completely different signals) to 1 (perfectly identical signals).
      </p>
      <p>
        For deformation monitoring, coherence tells us how reliable the phase difference
        (interferogram) is for measuring ground displacement. High coherence means that the surface
        properties haven’t changed much between radar acquisitions, so we can confidently extract
        deformation information. Low coherence, on the other hand, indicates changes due to
        vegetation growth, land use changes, or atmospheric noise, making deformation measurements
        less reliable.
      </p> -->
      <template v-for="(paragraph, index) in drawer.content" :key="index">
        <p class="drawer-content">{{ paragraph }}</p>
      </template>
      <Divider />
    </Drawer>
  </div>
  <div class="build-info" aria-label="Application build information">
    <span class="build-info-icon" aria-hidden="true">i</span>
    <span class="build-info-tooltip">Frontend identifier: {{ buildInfo }}</span>
  </div>
</template>

<style>

@import '@/assets/base.css';

.build-info {
  position: fixed;
  left: 1rem;
  bottom: 1rem;
  z-index: 1000;
}

.build-info-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 1.5rem;
  height: 1.5rem;
  border-radius: 999px;
  background-color: rgba(33, 37, 41, 0.78);
  color: white;
  font-size: 0.85rem;
  font-weight: 700;
  cursor: default;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.18);
}

.build-info-tooltip {
  position: absolute;
  right: 0;
  bottom: calc(100% + 0.5rem);
  max-width: min(18rem, calc(100vw - 2rem));
  padding: 0.5rem 0.75rem;
  border-radius: 0.5rem;
  background-color: rgba(33, 37, 41, 0.94);
  color: white;
  font-size: 0.8rem;
  line-height: 1.4;
  white-space: nowrap;
  opacity: 0;
  pointer-events: none;
  transform: translateY(0.25rem);
  transition: opacity 0.2s ease, transform 0.2s ease;
  box-shadow: 0 10px 24px rgba(0, 0, 0, 0.22);
  box-sizing: border-box;
}

.build-info:hover .build-info-tooltip {
  opacity: 1;
  transform: translateY(0);
}

.drawer-content {
  margin-bottom: 1rem;
}
</style>
